<template>
  <div class="d-flex">
    <base-button
      v-show="hideBackButton"
      large
      class="flex-grow-1 grey-lighten-3 text-capitalize"
      @click="handleClickBack"
    >
      <base-icon mdi="arrow-left" small class="mr-1"></base-icon>
      {{ $t('actions.back') }}
    </base-button>
    <base-button
      large
      class="flex-grow-1 grey-lighten-3 text-capitalize"
      @click="handleClickClose"
    >
      <base-icon mdi="close" small class="mr-1"></base-icon>
      {{ $t('actions.close') }}
    </base-button>
  </div>
</template>

<script>
import BaseIcon from '~/components/base/icon/BaseIcon'
import BaseButton from '~/components/base/button/BaseButton'
import { useUiEvent } from '~/composables'

export default {
  name: 'NavigatorDrawerNavigationButtons',
  components: { BaseButton, BaseIcon },
  props: {
    hideBackButton: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { root, emit }) {
    const uiEventBack = useUiEvent(root, 'back-bottom', 'navigator')
    const uiEventClose = useUiEvent(root, 'close-bottom', 'navigator')

    const handleClickBack = () => {
      emit('click:back')

      uiEventBack()
    }

    const handleClickClose = () => {
      emit('click:close')

      uiEventClose()
    }

    return {
      handleClickBack,
      handleClickClose,
    }
  },
}
</script>
